import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Empathy from "@/components/landing/Empathy";
import Promise from "@/components/landing/Promise";
import Merilyn from "@/components/landing/Merilyn";
import Services from "@/components/landing/Services";
import Process from "@/components/landing/Process";
import Portfolio from "@/components/landing/Portfolio";
import Testimonials from "@/components/landing/Testimonials";
import Offer from "@/components/landing/Offer";
import LeadMagnet from "@/components/landing/LeadMagnet";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";

export default function Landing() {
    return (
        <main data-testid="landing-page" className="bg-pearl text-cacao">
            <Nav />
            <Hero />
            <Empathy />
            <Portfolio />
            <Promise />
            <Merilyn />
            <Services />
            <Process />
            <Testimonials />
            <Offer />
            <LeadMagnet />
            <Contact />
            <Footer />
        </main>
    );
}
